import { useEffect, useState, useCallback } from 'react';
import { Select, DatePicker, Cascader } from 'antd';
import locale from 'antd/locale/zh_CN';
import 'dayjs/locale/zh-cn';

import request from '@/request';

const { RangePicker } = DatePicker;

export default function SelectorItem({
  label = '',
  require = false,
  onChange,
  value = [],
  type = 'default',
  options = [],
  className = '',
  disabled = false,
}) {
  const [areaData, setAreaData] = useState([]);
  useEffect(() => {
    if (type === 'address') {
      (async () => {
        const data = await request.get('/system/area/list');
        setAreaData(data || []);
      })();
    }
  }, [type]);

  const onSelectCity = useCallback(
    (v) => {
      const province = areaData.find((item) => item.value === v[0]) || {};
      const city =
        (province.children || []).find((item) => item.value === v[1]) || {};
      onChange({
        name: `${province.label || ''}${city.label || ''}`,
        areaCode: city.value || '',
      });
    },
    [areaData, onChange]
  );

  const getAddressValue = useCallback(() => {
    if (!value) return [];
    if (Array.isArray(value)) return value;
    /* 优先通过 areaCode 反查省市 codes，避免依赖正则解析名称字符串
       （直辖市或标签无省/市后缀时正则会失效，导致首次选择后显示空白） */
    if (value?.areaCode && areaData.length) {
      for (const province of areaData) {
        const city = (province.children || []).find(
          (c) => c.value === value.areaCode
        );
        if (city) return [province.value, city.value];
      }
    }
    /* 兜底：按名称解析（兼容历史字符串格式的 cityName） */
    const match = (value?.name || value).match(/省(.*)市/);
    const cityName = match ? match[1] + '市' : '';
    for (const province of areaData) {
      if (province.children) {
        for (const city of province.children) {
          if (city.label === cityName) {
            return [province.value, city.value];
          }
        }
      }
    }
    return [];
  }, [areaData, value]);

  return (
    <div className={`flex flex-col ${className}`}>
      <label className="flex items-start text-sm font-medium text-gray-700 mb-1">
        {require && <span className="text-red-500 mr-1">*</span>}
        {label}
      </label>
      <div className="w-full flex items-start">
        {type === 'default' && (
          <Select
            onChange={onChange}
            options={options}
            placeholder="请选择"
            value={value || undefined}
            disabled={disabled}
            className="min-w-45 flex-1 h-10"
          />
        )}
        {type === 'date' && (
          <RangePicker
            showTime={false}
            format="YYYY/MM/DD"
            value={value}
            placeholder={['开始日期', '结束日期']}
            onChange={onChange}
            locale={locale.DatePicker}
            className="w-full h-10"
            require={require}
            disabled={disabled}
          />
        )}
        {type === 'time' && (
          <RangePicker
            showTime={{ format: 'HH:mm' }}
            format="YYYY-MM-DD HH:mm"
            value={value}
            placeholder={['开始时间', '结束时间']}
            onChange={onChange}
            locale={locale.DatePicker}
            className="w-full h-10"
            disabled={disabled}
          />
        )}
        {type === 'address' && (
          <Cascader
            value={getAddressValue()}
            showSearch={true}
            options={areaData}
            onChange={onSelectCity}
            disabled={disabled}
            style={{ width: '100%' }}
            placeholder="请选择省市"
            className="w-full h-10"
          />
        )}
      </div>
    </div>
  );
}
